import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Box,
  Button,
  ButtonProps,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material'
import { UploadWithLink } from '../types/Upload'

interface BlueprintPdfViewerButtonProps extends Omit<ButtonProps, 'onClick'> {
  upload: UploadWithLink
}

export default function BlueprintPdfViewerButton({
  upload,
  children,
  ...props
}: BlueprintPdfViewerButtonProps) {
  const { t } = useTranslation('common')
  const [open, setOpen] = useState(false)

  const isPdf = upload.blueprint.mimeType === 'application/pdf'

  if (!isPdf || !upload.url) {
    return null
  }

  return (
    <>
      <Button {...props} onClick={() => setOpen(true)}>
        {children ?? t('Uploads.viewFile')}
      </Button>

      <Dialog open={open} onClose={() => setOpen(false)} fullScreen>
        <DialogTitle>{upload.blueprint.name}</DialogTitle>

        <DialogContent sx={{ p: 0 }}>
          <Box
            component="iframe"
            src={upload.url}
            title={upload.blueprint.name}
            sx={{
              width: '100%',
              height: 'calc(100vh - 120px)',
              border: 0,
              display: 'block'
            }}
          />
        </DialogContent>

        <DialogActions>
          <Button component="a" href={upload.url} target="_blank" rel="noopener noreferrer">
            {t('openInNewTab')}
          </Button>

          <Button variant="contained" onClick={() => setOpen(false)}>
            {t('close')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
